import { type MenuItem } from '@kijiji/generated/graphql-types'

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const isMenuItem = (menu?: any): menu is MenuItem =>
  (menu as MenuItem)?.__typename === 'MenuItem'

export const isMenuitemArray = (menu?: unknown[]): menu is MenuItem[] =>
  !(menu as MenuItem[])?.find((item) => item.__typename !== 'MenuItem')
